export const getPostiveValue = (value) => (value < 0 ? 0 : value);
